export const GetPetDetailsFromPolicyNumber = ({ petDetails, policyNumber }) => {
  return petDetails?.find(
    (petDetail) => petDetail.PolicyNumber === policyNumber || petDetail.FullPolicyNumber === policyNumber
  );
};

export const KeyPetPoliciesByName = ({ petDetails }) => {
  return petDetails?.reduce((acc, petDetail) => {
    acc[petDetail.Name] = petDetail;
    return acc;
  }, {});
};

export const GetPetDetailsFromPetName = ({ petDetails, petName }) => {
  return petDetails?.find((petDetail) => petDetail?.Name === petName);
};

export const GetPetDropdownOptions = ({ petDetails }) => {
  return petDetails?.reduce((acc, petDetail) => {
    acc.push({
      value: petDetail?.FullPolicyNumber,
      label: petDetail.Name
    });
    return acc;
  }, []);
};

export const GetPetPolicyNumberDropdownOptions = ({ petDetails }) => {
  return petDetails?.reduce((acc, petDetail) => {
    acc.push({
      value: petDetail?.PolicyNumber,
      label: petDetail.Name
    });
    return acc;
  }, []);
};

export const GetPetIconCssClassFromPolicyNumber = ({ petDetails, policyNumber }) => {
  const petDetail = GetPetDetailsFromPolicyNumber({
    petDetails,
    policyNumber
  });

  const {
    PolicyDetails: { PetGender },
    Species
  } = petDetail;

  if (Species === 'Canine') {
    return `dog-profile-${PetGender}`.toLowerCase();
  }
  return `cat-profile-${PetGender}`.toLowerCase();
};

export const getAgeInDays = (date) => {
  if (!date) {
    throw new Error('A valid date is required');
  }

  const givenDate = new Date(date);
  const currentDate = new Date();

  if (Number.isNaN(givenDate)) {
    throw new Error('Invalid date format');
  }

  const timeDifference = currentDate - givenDate; // Difference in milliseconds
  const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24)); // Convert to days

  return daysDifference;
};

export const getPetNames = (petDetails) => {
  const names = petDetails.map((pet) => pet.Name);
  const formattedPetNames =
    names.length > 1 ? `, ${names.slice(0, -1).join(', ')} & ${names.at(-1)}` : ` & ${names.join('')}`;
  return formattedPetNames;
};

export const getMinPolicyStartDate = (petDetails) => {
  const policyStartDates = petDetails?.map((pet) => new Date(pet.PolicyDetails.PolicyStartDate));
  return new Date(Math.min(...policyStartDates));
};
